// extracted by mini-css-extract-plugin
module.exports = {"container":"CourierChatComponent_container__bAsAX","open":"CourierChatComponent_open__R7e-u"};